export const multiplySize = (s, ratio) => ({
    width : s.width  * ratio,
    height: s.height * ratio,
});
